export default __webpack_public_path__ + "static/media/iq-img2-w.5c212ddb.png";